// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"dd7cfcc0","358":"ad8c31c4","551":"dce957c9","828":"0e5e737c","869":"fe6936ef"}[chunkId] + ".chunk.js";
};